import { useEffect } from "react";

/**
 * Lightweight per-route SEO setter. Updates document.title, meta description
 * and a JSON-LD script tag (id "page-jsonld") if provided.
 */
export default function useSEO({ title, description, canonical, jsonLd }) {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            let m = document.querySelector('meta[name="description"]');
            if (!m) {
                m = document.createElement("meta");
                m.name = "description";
                document.head.appendChild(m);
            }
            m.setAttribute("content", description);
        }
        if (canonical) {
            let l = document.querySelector('link[rel="canonical"]');
            if (!l) {
                l = document.createElement("link");
                l.rel = "canonical";
                document.head.appendChild(l);
            }
            l.setAttribute("href", canonical);
        }
        if (jsonLd) {
            let s = document.getElementById("page-jsonld");
            if (!s) {
                s = document.createElement("script");
                s.type = "application/ld+json";
                s.id = "page-jsonld";
                document.head.appendChild(s);
            }
            s.textContent = JSON.stringify(jsonLd);
        }
        return () => {
            const s = document.getElementById("page-jsonld");
            if (s) s.remove();
        };
    }, [title, description, canonical, jsonLd]);
}
